import { createStore, applyMiddleware, Store } from "redux";
import createSagaMiddleware from "redux-saga";
import thunkMiddleware from "redux-thunk";

// Only for Development
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";

// Only for Production
//import { composeWithDevTools } from "redux-devtools-extension/logOnlyInProduction";

import rootReducers from "./reducers/root.reducer";
import rootSaga from "./sagas/root.saga";
import eventsSaga from "./sagas/events.saga";
import attendeesSaga from "./sagas/attendees.saga";
import subscriptionsSaga from "./sagas/subscriptions.saga";
import reportsSaga from "./sagas/reports.saga";

// Custom middleware if required, add result to const middleware
// const customMiddleWare = (store) => (next) => (action) => {
//   console.log("Middleware triggered:", action);
//   next(action);
// };

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware, thunkMiddleware];

const store: Store = createStore(
  rootReducers,
  composeWithDevTools(applyMiddleware(...middleware))
);

store.subscribe(() => { });
sagaMiddleware.run(rootSaga);
sagaMiddleware.run(eventsSaga);
sagaMiddleware.run(attendeesSaga);
sagaMiddleware.run(subscriptionsSaga);
sagaMiddleware.run(reportsSaga);

export default store;
